<div class="homepage-container dark">
  <div class="homepage-lang">
    <button type="button" class="lang-toggle" (click)="toggleLanguageMenu()" [attr.aria-expanded]="openLanguageMenu">
      <i [ngClass]="getLanguageFlag('')"></i>
      <span>{{ languageDescription }}</span>
      <i class="fa-solid fa-chevron-down lang-chevron" [class.open]="openLanguageMenu"></i>
    </button>
    @if (openLanguageMenu) {
      <ul class="lang-menu">
        <li>
          <button type="button" class="lang-menu-item" (click)="useLanguage('en')">
            <i class="fi fi-us"></i>
            <span>English</span>
          </button>
        </li>
        <li>
          <button type="button" class="lang-menu-item" (click)="useLanguage('pt-BR')">
            <i class="fi fi-br"></i>
            <span>Portuguese (BR)</span>
          </button>
        </li>
        <li>
          <button type="button" class="lang-menu-item" (click)="useLanguage('pt-PT')">
            <i class="fi fi-pt"></i>
            <span>Portuguese (PT)</span>
          </button>
        </li>
      </ul>
    }
  </div>
  <div class="homepage-layout">

    <!-- Coluna visual -->
    <div class="homepage-visual">
      <img
        src="../assets/images/studio.png"
        alt="Calipoli Studio"
      />
      <div class="visual-overlay"></div>
    </div>

    <!-- Coluna de conteúdo -->
    <div class="homepage-content">
      <div class="headline">
        <h1>{{ 'main.title' | translate }}</h1>
        <h2>{{ 'main.subtitle' | translate }}</h2>

        <p class="description">
          {{ 'main.description' | translate }}
        </p>

        <a
          [routerLink]="['/user/login']"
          class="clp-btn clp-btn-warning btn-enter"
        >
          {{ 'main.cta.enter' | translate }}
        </a>
      </div>
    </div>

  </div>
</div>
